import { useEventContent } from "@/context/EventContentContext";

export default function Menu() {
  const { menu } = useEventContent();

  return (
    <div data-testid="menu-page" className="section-pad">
      <div className="container-cg">
        <div className="overline text-[var(--brand-primary)]">Experiencia gastronómica</div>
        <h1 className="font-serif-cg text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3">
          Un menú de cinco tiempos.
        </h1>
        <p className="max-w-2xl mt-5 text-[var(--brand-muted)] leading-relaxed">
          Cada tiempo está pensado como un capítulo de la memoria gastronómica del Bajío, contado por nuestros chefs invitados.
        </p>

        <div className="mt-14 space-y-10 md:space-y-16">
          {menu.map((dish, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <article
                key={dish.name}
                data-testid={`dish-${idx}`}
                className={`grid md:grid-cols-12 gap-6 md:gap-10 items-center ${
                  reverse ? "md:[&>div:first-child]:order-2" : ""
                }`}
              >
                <div className="md:col-span-7 img-zoom-host overflow-hidden card-cg">
                  <img src={dish.image} alt={dish.name} className="img-zoom w-full aspect-[4/3] object-cover" />
                </div>
                <div className="md:col-span-5">
                  <div className="overline text-[var(--brand-accent)]">{`Tiempo ${idx + 1} · ${dish.course}`}</div>
                  <h3 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-2">{dish.name}</h3>
                  <p className="mt-4 leading-relaxed text-[var(--brand-ink)]/85">{dish.description}</p>
                  <div className="hairline my-5" />
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <div className="overline text-[var(--brand-muted)] mb-1">Chef responsable</div>
                      <div>{dish.chef}</div>
                    </div>
                    <div>
                      <div className="overline text-[var(--brand-muted)] mb-1">Maridaje</div>
                      <div>{dish.pairing}</div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <div className="overline text-[var(--brand-muted)] mb-2">Ingredientes principales</div>
                    <div className="flex flex-wrap gap-2">
                      {dish.ingredients.map((i) => (
                        <span
                          key={i}
                          className="text-xs px-3 py-1 border border-[var(--brand-border)] bg-white"
                        >
                          {i}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}
